import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Row,
  Input,
  FormGroup,
} from "reactstrap";
import _ from "underscore";
import IconButton from "../../../elements/IconButton";

interface Props {
  editMode: boolean;
  reorderSection: any;
  section: any;
  index: number;
  sectionsLength: number;
  removeSection: any;
  infoChange: any;
  body: any;
}

const WidgetSection = ({
  editMode,
  reorderSection,
  section,
  index,
  sectionsLength,
  removeSection,
  infoChange,
  body,
}: Props) => {
  return (
    <Card className={`border bg-white shadow-none`} key={index}>
      <CardHeader className={`bg-ultralight py-2 border-bottom`}>
        {editMode ? (
          <>
            <Row className="align-items-center">
              <Col xs="auto" className="pr-0">
                <IconButton
                  icon="chevron-up"
                  onClick={() => reorderSection(section, -1)}
                  disabled={index === 0}
                />
                <IconButton
                  icon="chevron-down"
                  onClick={() => reorderSection(section, 1)}
                  disabled={index === sectionsLength - 1}
                />
              </Col>
              <Col>
                <h4 className="mb-0">{section.Title}</h4>
                {section.Description && !editMode && (
                  <p className="mb-0">
                    <small>{section.Description}</small>
                  </p>
                )}
              </Col>
              <Col xs="auto" className="text-right">
                <IconButton
                  icon="delete"
                  color="danger"
                  onClick={() => {
                    removeSection(section.id);
                  }}
                />
              </Col>
            </Row>
          </>
        ) : (
          <>
            <h4 className="mb-0">{section.Title}</h4>
            {section.Description && (
              <p className="mb-0">
                <small>{section.Description}</small>
              </p>
            )}
          </>
        )}
      </CardHeader>
      {editMode && (
        <CardBody className="border-bottom pb-0 pt-4">
          <Row className="align-items-center">
            <Col>
              <h5 className="text-uppercase text-dark m-0">Information</h5>
            </Col>
          </Row>
          <FormGroup className="mt-3">
            <h5 className="text-muted">Name</h5>
            <Input
              bsSize="sm"
              onChange={(e) => infoChange(e, section)}
              placeholder="Name"
              type="text"
              name="Title"
              value={section.Title}
            ></Input>
          </FormGroup>
          <FormGroup>
            <h5 className="text-muted">Description</h5>
            <Input
              bsSize="sm"
              type="textarea"
              onChange={(e) => infoChange(e, section)}
              placeholder="Description"
              name="Description"
              value={section.Description}
            ></Input>
          </FormGroup>
        </CardBody>
      )}
      <CardBody>{body}</CardBody>
    </Card>
  );
};

export default WidgetSection;
